const premium = {
  coupon: {
    placeholder: "Añadir cupón",
    success: {
      title: "¡Éxito!",
      message: "Su cupón ha sido redimido",
    },
    error: {
      title: "¡Uh-oh!",
      message: "Código de Cupón Incorrecto",
    },
    redeem: "Redimir",
    payment_one: "pago",
    payment_other: "{{ count }} pagos",
    coupon_applied: "¡Felicidades! Recibirá un descuento del {{ discount }} en sus primeros {{ duration }}",
  },
  payment: {
    title: "Forma de pago",
    subtitle: "Seleccione cómo le gustaría pagar para empezar a disfrutar sus beneficios",
    plan_type: "Tipo de plan:",
    plan_price: "Precio de plan:",
    membership: "Membresía anual SEP+ ",
    annual_membership: "Membresía anual",
    monthly_membership: "Membresía mensual",
    monthly: "Mensual",
    price: "Precio",
    duration: "mes",
    credit_card_number: "Número de tarjeta",
    expiry: "Expiración mm/aa",
    cvv: "CVV",
    confirm_purchase: "Confirmar compra",
    failure_title: "¡Uh-oh!",
    product_name: "Membresía Premium",
    or: "O",
    pay_with_card: "pague con tarjeta",
    update_and_pay: "Actualizar + Pagar",
    yearly: "Anual",
    proceed: "Continuar a Pago",
  },
  past_due: {
    success_title: "Felicidades",
    success_message: "Su pago se ha procesado correctamente y la información de su tarjeta se ha actualizado.",
  },
  not_available: "Lo sentimos, este producto no está disponible en su estado.",
  update_payment: {
    success_title: "Felicidades",
    // TODO: This is probably wrong.  We don't have copy for this in proton
    success_message: "La información de su tarjeta se ha actualizado.",
  },
  annual: {
    billed_annually: "Un solo cobro <strong>anual</strong>",
    billed_monthly: "Cobro <strong>mensual</strong>",
    discount_percentage: "{{ discount }}% de descuento",
    months_free: "{{ number }} meses gratis",
    no_discount: "Sin discuento",
    pay_full_price: "Pagar sin descuento",
    per_month: "/ mes",
    per_year: "/ año",
  },
};

export default premium;
